import { FunctionComponent, useEffect, useState } from 'react';
import styles from './ColorManager.module.scss';
import ColorComponent from './ColorComponent';
import { useMasterData } from 'hooks';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import clsx from 'clsx';
import { DescriptionText } from '../DescriptionText/DescriptionText';

interface ColorManagerProps {
    color?: string | null;
    onChange: (color: string | null) => void;
    className?: string;
    label?: string;
    labelDescription?: string;
    error?: string | null;
    required?: boolean;
    id?: string;
}

export const ColorManager: FunctionComponent<ColorManagerProps> = ({
    color,
    onChange,
    className,
    label,
    labelDescription,
    error,
    required,
    id
}) => {
    const masterData = useMasterData();
    const [selectedColor, setSelectedColor] = useState<string | null | undefined>(color);

    useEffect(() => {
        setSelectedColor(color);
    }, [color]);

    const containerClasses = clsx(styles.container, className);
    const colorContainerClasses = clsx(styles.colorContainer, {
        [styles.error]: error
    });

    return (
        <div className={containerClasses}>
            {(label || error) && (
                <Label
                    required={required}
                    error={error}
                    htmlFor={id}
                >
                    {label}
                </Label>
            )}
            {labelDescription && (
                <DescriptionText
                    text={labelDescription}
                    className={styles.labelDescription}
                />
            )}
            <div className={colorContainerClasses}>
                <ColorComponent
                    color="inherit"
                    selected={!selectedColor}
                    onSelect={() => {
                        setSelectedColor(null);
                        onChange(null);
                    }}
                />
                {masterData.serviceColors.map(color => (
                    <div
                        className={styles.colorBox}
                        key={color.id}
                    >
                        <ColorComponent
                            color={color.name}
                            selected={selectedColor === color.id}
                            onSelect={() => {
                                setSelectedColor(color.id);
                                onChange(color.id);
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ColorManager;
